'use client';
import type { ForwardRefRenderFunction } from 'react';
import { forwardRef } from 'react';

import { useRouter } from 'next/navigation';

import SettingsIcon from '@mui/icons-material/Settings';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';

import { t } from '@/utils/lang';

const AppConfigDropdown: ForwardRefRenderFunction<HTMLButtonElement> = (
    _props,
    ref
) => {
    const route = useRouter();

    return (
        <Tooltip
            title={t('Cấu hình')}
            PopperProps={{ className: 'capitalize' }}
        >
            <span className='inline-flex'>
                <IconButton
                    ref={ref}
                    onClick={() => {
                        route.push('/app-config');
                    }}
                    className='!text-textPrimary'
                >
                    <SettingsIcon />
                </IconButton>
            </span>
        </Tooltip>
    );
};

export default forwardRef(AppConfigDropdown);
